import { render } from "./copy-dataset.vue?vue&type=template&id=8bb41cd0"
import script from "./copy-dataset.vue?vue&type=script&lang=js"
export * from "./copy-dataset.vue?vue&type=script&lang=js"

import "./copy-dataset.vue?vue&type=style&index=0&id=8bb41cd0&lang=css"
script.render = render

export default script